import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularChevronDown: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_chevron-down"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="chevron-down icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M4.21967 8.46967C4.51256 8.17678 4.98744 8.17678 5.28033 8.46967L12 15.1893L18.7197 8.46967C19.0126 8.17678 19.4874 8.17678 19.7803 8.46967C20.0732 8.76256 20.0732 9.23744 19.7803 9.53033L12.5303 16.7803C12.2374 17.0732 11.7626 17.0732 11.4697 16.7803L4.21967 9.53033C3.92678 9.23744 3.92678 8.76256 4.21967 8.46967Z" />
      </svg>
    </span>
  );
};

export { RegularChevronDown };
